module.exports = __webpack_public_path__ + "static/fonts/ProximaNova-Semibold.30780ee0.woff";